import {getHost} from "@/hooks/fnHelper";
import {useCookies} from "vue3-cookies";
import {getUserDataFromAccount, svodApi} from "@/api/svodApi";
import deleteNonValidCookie from "@/hooks/deleteNonValidCookie";

export const initAppPlugin = async (app) => {
    const {cookies} = useCookies();

    deleteNonValidCookie();

    const getServerSid = async (tries = 0) => {
        const host = getHost();
        console.log('getServerSid host', host);

        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.get('xuid') && cookies.isKey("gazprom_sid") && cookies.get("gazprom_sid") === urlParams.get('xuid')) {
            cookies.set("server_sid", urlParams.get('xuid'), null, null, host);
            cookies.remove('gazprom_sid', null, this.host);
        }

        try {
            const {data: apiData} = await svodApi.get('/lk?scope=lk+systems+auth' + (cookies.isKey('server_sid') ? '&mrktsid=' + cookies.get("server_sid") : ''));
            // console.log('apiData', apiData)
            if (!apiData?.mrktid) {
                throw new Error('No sid');
            }

            let userData = getUserDataFromAccount(apiData);
            // console.log('userData', userData,app, app._context)
            app.config.globalProperties.$userAccounts = apiData.xAccounts;

            if (userData) {
                app.config.globalProperties.$user = userData;
            }

            cookies.set('server_sid', apiData.mrktid, null, null, host);
            svodApi.defaults.headers.mrktsid = apiData.mrktid;
            // await delay(250);
        } catch (e) {
            console.log('e', e)
            if (tries < 5) {
                return await getServerSid(++tries);
            }
        }
    }

    const getServerRoutes = async (tries = 0) => {
        try {
            const {data: serverRouters} = await svodApi.get('/salegroups?t=all', {
                timeout: 10000
            });

            app.config.globalProperties.$serverRouters = serverRouters;
        } catch (e) {
            if (tries < 5) {
                return await getServerRoutes(++tries);
            }
            throw e;
        }
    }

    const delay = async (ms) => await new Promise(resolve => setTimeout(resolve, ms));

    await getServerSid();
    await getServerRoutes();
}